import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  fetchContext,
  fetchStockLocations,
  setFilters,
  updateBatches,
  runModalAction,
  createVariants,
  fetchTemplate,
  setTemplate,
  saveTemplates,
  fetchVariantSelectedProducts,
  refreshKey,
} from '../actions/batchesActions'
import batchesState, { BatchesState } from '../states/batchesState'
import objectToCamelCase from '../../utils/objectToCamelCase'

export const batchesSlice = createSlice({
  name: 'batches',
  initialState: batchesState as BatchesState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setFilters,
      (state, action: PayloadAction<Record<string, string>>) => {
      state.filters = action.payload
    }
  )

    builder.addCase(refreshKey, (state) => {
      state.refreshKey += 1
    })

    builder.addCase(updateBatches.pending, (state) => {
      state.isBatchesUpdating = true
    })
    builder.addCase(updateBatches.fulfilled, (state) => {
      state.isBatchesUpdating = false
      state.refreshKey += 1
    })
    builder.addCase(updateBatches.rejected, (state) => {
      state.isBatchesUpdating = false
    })

    builder.addCase(createVariants.pending, (state) => {
      state.isBatchesUpdating = true
    })
    builder.addCase(createVariants.fulfilled, (state) => {
      state.isBatchesUpdating = false
      state.refreshKey += 1
    })
    builder.addCase(createVariants.rejected, (state) => {
      state.isBatchesUpdating = false
    })

    builder.addCase(fetchStockLocations.pending, (state) => {
      state.isStockLocations = true
    })
    builder.addCase(
      fetchStockLocations.fulfilled,
      (state, action) => {
        state.stockLocations = action.payload.stock_locations
        state.isStockLocations = false
      }
    )
    builder.addCase(fetchStockLocations.rejected, (state) => {
      state.isStockLocations = false
    })

    builder.addCase(fetchContext.fulfilled, (state, action) => {
      state.context = objectToCamelCase(action.payload)
    })

    builder.addCase(runModalAction.pending, (state) => {
      state.isModalLoading = true
    })
    builder.addCase(runModalAction.fulfilled, (state) => {
      state.isModalLoading = false
    })
    builder.addCase(runModalAction.rejected, (state) => {
      state.isModalLoading = false
    })

    builder.addCase(fetchTemplate.pending, (state) => {
      state.isTemplateLoading = true
    })
    builder.addCase(fetchTemplate.fulfilled, (state, action) => {
      state.isTemplateLoading = false
      state.template = action.payload
      state.downloadedTemplate = action.payload
    })
    builder.addCase(fetchTemplate.rejected, (state) => {
      state.isTemplateLoading = false
      state.template = null
      state.downloadedTemplate = null
    })

    builder.addCase(
      setTemplate,
      (state, action: PayloadAction<Partial<BatchesState['template']>>) => {
      if (state.template) {
        state.template = { ...state.template, ...action.payload }
      }
    }
  )

    builder.addCase(saveTemplates.pending, (state) => {
      state.isTemplateLoading = true
    })
    builder.addCase(saveTemplates.fulfilled, (state) => {
      state.isTemplateLoading = false
      state.downloadedTemplate = state.template
    })
    builder.addCase(saveTemplates.rejected, (state) => {
      state.isTemplateLoading = false
    })

    builder.addCase(
      fetchVariantSelectedProducts.fulfilled,
      (state, action) => {
        const results = action.payload.results as Array<{ id: string; name: string }>
        results.forEach((cur) => {
          state.variantSelectedProducts[cur.id] = cur.name
        })
      }
    )
  },
})

export default batchesSlice.reducer